module.exports = __webpack_public_path__ + "static/media/icon-config.54d2feb5.svg";